import React, { useState, useEffect } from 'react';
import styles from './style/index.module.less';
import { Popover, Button } from '@arco-design/web-react';
import axiosInstance from '@/utils/axiosInstance';

interface TopListProps {

  children: React.ReactNode;
	kfimg:string;
	miniprogramQrcode:string;
}

function TopList(props: TopListProps) {
	const serviceLevel = localStorage.getItem("service_level");
	const systemType =  localStorage.getItem("systemType");
	// const [kfimg,setkfimg] = useState('');

	// function config() {
	//   axiosInstance.get('/system/config')
	//     .then((res) => {
	//       const { code, msg } = res.data;
	//       if (res.data.code === 0) {
	// 		setkfimg(res.data.data.custom_qrcode_url)
	//       }
	//     })
	// }

	// function info() {
	//   axiosInstance.get('/user/info')
	//     .then((res) => {
	//       const { code, msg } = res.data;
	
	//       if (res.data.code === 0) {
	// 		setexpireTimeStr(res.data.data.expire_time_str)
	// 		setisExpire(res.data.data.is_expire);
	//       }
	//     })
	// }
	// useEffect(() => {
	// 	config();
	// 	//info();
	// }, []);
	const styles1 = {
		color: 'red',
		marginRight:'30px',
		marginTop:'2px'
	};
	const styles2 = {
		color: 'green',
		marginRight:'30px',
		marginTop:'2px'
	};
	return (
		<div style={{display:'flex'}} >
			{serviceLevel =='0' &&(
				<>
				{systemType == '1' &&(
					<div  style={{marginRight:15}}>
						<img style={{width:170,height:50,marginTop:14}} src="https://haitzhitou.oss-cn-shanghai.aliyuncs.com/feed/1e2cdcaf16ad37f9ae7c82b5cee7194.png" />
					</div>
				)}
				{systemType == '2' &&(	
					<div  style={{marginRight:15}}>
						<img style={{width:170,height:50,marginTop:14}} src="https://haitzhitou.oss-cn-shanghai.aliyuncs.com/feed/75d83bcd983544ba369217b9f807191.png" />
					</div>
				)}
				</>
			)}

			
			<Popover
			title=""
				  content={
					<div style={{display:'inline-block'}}>
						<div>
							<img style={{display:'block',maxWidth:'100%',height:'auto'}} src={props.kfimg}></img>
						</div>
						<div style={{textAlign:'center',marginTop:4}}>
							{/* 联系客服领 <span style={{color:'red'}}>3 </span>天会员 */}
							{/* 联系客服开会员，有优惠活动 */}
						</div>
					</div>
				  }
				>
				<div className={styles['right-box'] + ' main-color'}>
					<div><i className={styles['right-icon']+' iconfont'} style={{fontSize:17}}>&#xe68b;</i></div>
					<div className={styles['right-text-icon']}>找客服</div>
				</div>
			</Popover>
			{/*
			{(props.miniprogramQrcode!=''&&props.miniprogramQrcode!=null) &&(
			*/}
				<Popover
				title=""
					  content={
						<div style={{display:'inline-block'}}>
							<div>
							<img style={{display:'block',maxWidth:'100%',height:'auto'}} src={props.miniprogramQrcode}></img>
							</div>
							<div style={{textAlign:'center',marginTop:4}}>
								随时监控投流数据，管理视频号
							</div>
						</div>
					  }
					>
					<div style={{marginLeft:10}} className={styles['right-box'] + ' main-color'}>
						<div><i className={styles['right-icon']+' iconfont'} style={{fontSize:14}}>&#xe62d;</i></div>
						<div className={styles['right-text-icon']}>小程序</div>
					</div>
				</Popover>
			{/*
				)}
			*/}

			
		</div>

	);

}


export default TopList;
